"use client";

import React from "react";
import Image from "next/image";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import CarouselArrow from "./CarouselArrow";
import { CarouselProps } from "./types";

const Carousel: React.FC<CarouselProps> = ({
  images,
  uniqueKey,
  swiperRef,
  autoScroll,
}) => {
  return (
    <div className="relative w-full h-full">
      <Swiper
        className="absolute top-0 left-0 w-full h-full z-10"
        modules={[Navigation, Pagination, ...(autoScroll ? [Autoplay] : [])]}
        navigation={{
          nextEl: `.swiper-button-next-custom-${uniqueKey}`,
          prevEl: `.swiper-button-prev-custom-${uniqueKey}`,
        }}
        loop={images.length > 1}
        autoplay={
          autoScroll ? { delay: 3500, disableOnInteraction: false } : false
        }
        onSwiper={(swiper) => {
          if (swiperRef) {
            swiperRef.current = swiper;
          }
        }}
      >
        {images.map((image, index) => {
          const src = image.url || `/uploads/${image.filename}`;
          return (
            <SwiperSlide key={index}>
            <div className="relative w-full h-[600px] flex justify-center items-center">
              <Image
                src={src}
                alt={image.title || `Slide ${index + 1}`}
                className="w-full h-full object-fill"
                width={1200}
                height={800}
              />
            </div>
          </SwiperSlide>
          
          );
        })}
      </Swiper>
      <CarouselArrow
        position="prev"
        direction="left"
        customClass={`swiper-button-prev-custom-${uniqueKey}`}
      />
      <CarouselArrow
        position="next"
        direction="right"
        customClass={`swiper-button-next-custom-${uniqueKey}`}
      />
    </div>
  );
};

export default Carousel;
